export function sortCandidates(candidates, party) {
  let incumbent = _.filter(candidates, ['incumbent', 'y']);
  let challengers = _.sortBy(_.reject(candidates, ['incumbent', 'y']), 'lastName');
  let sorted = incumbent.concat(challengers);
  if (party) {
    return _.filter(sorted, ['party', party]);
  } else {
    return sorted;
  }
}

export function sortRaces({ district, races, isBrooklyn, isBronx, party }) {
  let sorted = [];

  // only Democrats are voting for mayor, public advocate, bronx boro pres, and brooklyn DA
  if (party === 'D') {
    sorted.push(races.mayor, races['Public Advocate']);

    if (isBrooklyn) {
      sorted.push(races.da);
    }
    if (isBronx) {
      sorted.push(races['Bronx']);
    }
  }
  if (races[`d${district}`]) {
    sorted.push(races[`d${district}`]);
  }
  return sorted;
}



// WEBPACK FOOTER //
// ./app/src/js/lib/sorting.js